<template>
  <div class="introduction">
    <div class="row">
      <div class="col-md-12">
          <h1>Doneren</h1>
          <p>Welkom...</p>
          <img src="../assets/logo.jpeg" width="400" alt="">
          <p>In samenwerking met:</p>
          <img src="../assets/Radboudumc-logo.png" width="200" alt="">
      </div>
    </div>
    <div class="row arrow">
      <div class="col-md-12">
        <router-link :to="{ name: 'Menu' }"><font-awesome-icon :icon="icon" /></router-link>
      </div>
    </div>
   </div>
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import faArrowDown from '@fortawesome/fontawesome-free-solid/faArrowDown'

export default {
  name: 'Introduction',
  computed: {
    icon () {
      return faArrowDown
    }
  },

  components: {
    FontAwesomeIcon
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Introduction.vue